import { __ } from "@wordpress/i18n";
import { useState, useEffect } from "@wordpress/element";
import { dispatch, useSelect } from "@wordpress/data";
import { Button } from "@wordpress/components";
import  BlockCard from "../components/BlockCard";
import {
  accordionIcon,
  paragraphIcon,
  videoPlayerIcon,
  shapeDividerIcon,
  postGridIcon,
  containerIcon,
  aiGeneration,
  businessHoursIcon,
  buttonsIcon,
  cartIcon,
  circleIcon,
  columnsIcon,
  comparisonTableIcon,
  countdownIcon,
  faIcon,
  flipIcon,
  formIcon,
  googleMapIcon,
  headingIcon,
  iconListIcon,
  lottieIcon,
  mapIcon,
  popupIcon,
  postsIcon,
  reviewIcon,
  searchIcon,
  sharingIcon,
  sliderIcon,
  progressIcon,
  tabsIcon,
  imageComparison,
  alertboxIcon,
  newsletterIcon,
  gridIcons,
  postCarouseIcon,
  postListIcon,
} from "../utils/icons";
const UltraBlocks = [
  {
    slug: "ultrablocks/paragraph",
    name: __("Paragraph", "ultrablocks"),
    icon: paragraphIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/grid",
    name: __("Grid", "ultrablocks"),
    icon: gridIcons,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/container",
    name: __("Container", "ultrablocks"),
    icon: containerIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/countdown",
    name: __("Countdown", "ultrablocks"),
    icon: countdownIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/google-maps",
    name: __("Google Maps", "ultrablocks"),
    icon: googleMapIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/tabs",
    name: __("Tabs", "ultrablocks"),
    icon: tabsIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/buttons",
    name: __("Buttons", "ultrablocks"),
    icon: buttonsIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/shape-divider",
    name: __("Shape Divider", "ultrablocks"),
    icon: shapeDividerIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/search",
    name: __("Search", "ultrablocks"),
    icon: searchIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/video",
    name: __("Video", "ultrablocks"),
    icon: videoPlayerIcon,
    docLink: "https://ultrablocks.pro",
    released: false,
  },
  {
    slug: "ultrablocks/newslatter",
    name: __("Newsletter", "ultrablocks"),
    icon: newsletterIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  // {
  //   slug: "ultrablocks/alertbox",
  //   name: __("Alertbox", "ultrablocks"),
  //   icon: alertboxIcon,
  //   docLink: "https://ultrablocks.pro",
  //   released: false,
  // },
  {
    slug: "ultrablocks/accordion",
    name: __("Accordion", "ultrablocks"),
    icon: accordionIcon,
    docLink: "https://ultrablocks.pro",
    released: true,
  },
  {
    slug: "ultrablocks/progress-bar",
    name: __("Progress bar", "ultrablocks"),
    icon: progressIcon,
    docLink: "https://ultrablocks.pro",
    released: false,
  },
  {
    slug: "ultrablocks/image-comparison",
    name: __("Image Comparison", "ultrablocks"),
    icon: imageComparison,
    docLink: "https://ultrablocks.pro",
    released: false,
  },
  {
    slug: "ultrablocks/post-grid",
    name: __("Post Grid", "ultrablocks"),
    icon: postsIcon,
    docLink: "https://ultrablocks.pro",
    released: false,
  },
  {
    slug: "ultrablocks/post-carousel",
    name: __("Post Carousel", "ultrablocks"),
    icon: postCarouseIcon,
    docLink: "https://ultrablocks.pro",
    released: false,
  },
  {
    slug: "ultrablocks/post-list",
    name: __("Post List", "ultrablocks"),
    icon: postListIcon,
    docLink: "https://ultrablocks.pro",
    released: false,
  },
  {
    slug: "ultrablocks/lottie",
    name: __("Lottie", "ultrablocks"),
    icon: lottieIcon,
    docLink: "https://ultrablocks.pro",
    released: false,
  },
].sort((a, b) => a.name.localeCompare(b.name));

/**
 * Dashboard Header component.
 * @param {import('../..').BlockCardHeaderProps} props Component props.
 */
const Header = ({ blocks, onDisableAll, onEnableAll, canDisplayBtn }) => {

	const allEnabled = blocks.every( block => ! block.isDisabled );
	const allDisabled = blocks.every( block => block.isDisabled );

	return <div className="ubs-blocks-header">
		<div className="ubs-blocks-header__left">
			<span>{ __( 'All Blocks', 'ultrablocks' ) }</span>
		</div>
		{
			canDisplayBtn && (
				<div className="ubs-blocks-header__right">
					<Button variant="secondary" disabled={allDisabled} onClick={onDisableAll} >
						{ __( 'Disable All', 'ultrablocks' ) }
					</Button>
					<Button variant="primary" disabled={allEnabled} onClick={onEnableAll}>
						{ __( 'Enable All', 'ultrablocks' ) }
					</Button>
				</div>
			)
		}
	</div>;
};
const Blocks = () => {
  const [blocksStatus, setBlocksStatus] = useState(UltraBlocks);
  	const [canShowNotice, canShowNoticeSet] = useState(false);


  const { preferencesHiddenBlocks, isLoading } = useSelect(
    (select) => {
      /**
       * Array of hidden block types.
       * @type {Array<string>|undefined}
       */
      const hiddenBlocks = select("core/preferences")?.get(
        "core",
        "hiddenBlockTypes"
      );

      const isResolving = select("core/preferences").isResolving("get", [
        "hiddenBlockTypes",
      ]);

      return {
        preferencesHiddenBlocks: hiddenBlocks
          ? new Set(hiddenBlocks)
          : undefined,
        isLoading: isResolving,
      };
    },
    [blocksStatus]
  );

  /**
   * Update the WP Option with the new value.
   * @param {import('../..').BlocksToDisableList} blocks Blocks to be updated.
   */
  const sendUpdates = (blocks) => {
    const newPreferencesHiddenBlocks = new Set();

    // Copy the old preferences.
    if (preferencesHiddenBlocks) {
      preferencesHiddenBlocks.forEach((block) => {
        newPreferencesHiddenBlocks.add(block);
      });
    }

    // Add the new preferences.
    blocks.forEach((block) => {
      if (block.isDisabled) {
        newPreferencesHiddenBlocks.add(block.slug);
      } else {
        newPreferencesHiddenBlocks.delete(block.slug);
      }
    });

    dispatch("core/preferences").set("core/edit-post", "hiddenBlockTypes", [
      ...newPreferencesHiddenBlocks,
    ]);
  };

  /**
   * Toggle the block status.
   * @param {string} blockSlug Block slug.
   */
  const toggleBlock = (blockSlug) => {
    const updatedBlocksStatus = blocksStatus.map((block) => {
      if (block.slug === blockSlug) {
        block.isDisabled = !block.isDisabled;
      }

      return block;
    });

    sendUpdates(updatedBlocksStatus);
    setBlocksStatus(updatedBlocksStatus);
    canShowNoticeSet(true);
  };

  /**
   * Disable all blocks and update the WP Option.
   */
  const onDisableAll = () => {
    const updatedBlocksStatus = blocksStatus.map((block) => {
      // if (block.isPro && !ultrablocksObj.hasPro) {
      //   return block;
      // }

      block.isDisabled = true;

      return block;
    });

    sendUpdates(updatedBlocksStatus);
    setBlocksStatus(updatedBlocksStatus);
    canShowNoticeSet(true);
  };

  /**
   * Enable all blocks and update the WP Option.
   */
  const onEnableAll = () => {
    const updatedBlocksStatus = blocksStatus.map((block) => {
      block.isDisabled = false;

      return block;
    });

    sendUpdates(updatedBlocksStatus);
    setBlocksStatus(updatedBlocksStatus);
    canShowNoticeSet(true);
  };

  /**
   * Initiate the blocks' status.
   */
  useEffect(() => {
    if (isLoading) {
      return;
    }

    const updatedBlocksStatus = blocksStatus.map((block) => {
      if (preferencesHiddenBlocks?.has(block.slug)) {
        block.isDisabled = true;
      } else {
        block.isDisabled = false;
      }

      return block;
    });

    setBlocksStatus(updatedBlocksStatus);
  }, [isLoading]);

  useEffect(() => {
    if (!canShowNotice || isLoading) {
      return;
    }

    dispatch?.("core/notices")?.createNotice(
      "info",
      __("Option Updated.", "ultrablocks"),
      { isDismissible: true, type: "snackbar", id: "saved-options" }
    );
    canShowNoticeSet(false);
  }, [canShowNotice, preferencesHiddenBlocks, isLoading]);
  return (
    <>
      <Header
        blocks={blocksStatus}
        onDisableAll={onDisableAll}
        onEnableAll={onEnableAll}
        canDisplayBtn={!isLoading}
      />

      <div className="ubs-block-cards">
        {blocksStatus.map((block, index) => {
          return (
            <BlockCard
              key={index}
              block={block}
              isLoading={isLoading}
              onToggle={() => toggleBlock(block.slug)}
            />
          );
        })}
      </div>
    </>
  );
};

export default Blocks;
